import React, { useState } from "react";
import "../auth.scss";
import { logodarkimg, logoimg } from "../../../assets/images";
import { callicon, messageicon } from "../../../assets/icons";
import Email from "./Email";
import Number from "./Number";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const SignUp = () => {
  const [propertyTab, setPropertyTab] = useState("email");

  //---------------------- Handle HTML CODE -----------------------//
  return (
    <>
      <Helmet defer={false}>
        <title>Create Account | Join Holypills for Better Health</title>
        <meta
          name="description"
          content="Sign up with Holypills to track your health, connect with doctors, and get expert guidance for women’s wellness and care."
        />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link rel="canonical" href="https://holypills.in/signup" />

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Create Account | Join Holypills for Better Health"
        />
        <meta
          property="og:description"
          content="Sign up with Holypills to track your health, connect with doctors, and get expert guidance for women’s wellness and care."
        />

        <meta property="og:url" content="https://holypills.in/signup" />
        <meta property="og:site_name" content="Holypills"></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Create Account | Join Holypills for Better Health"
        />
        <meta
          name="twitter:description"
          content="Sign up with Holypills to track your health, connect with doctors, and get expert guidance for women’s wellness and care."
        />

        <meta name="twitter:url" content="https://holypills.in/signup"></meta>
      </Helmet>
      <div className="wrapper_auth">
        <div className="wrap_left">
          <Link to={"/"}>
            <img src={logoimg} alt="logo" />
          </Link>
          <h1>
            Balance Your Body, <span></span> Empower Your Mind
          </h1>
        </div>
        <div className="wrap_right">
          <img className="logo" src={logodarkimg} alt="logo" />
          <h2>Welcome to HolyPills</h2>
          <div className="wrapper_cstm_tabers">
            <ul className="cstm_tabs">
              <li
                className={propertyTab === "email" ? "active" : ""}
                onClick={() => setPropertyTab("email")}
              >
                <img src={messageicon} alt="icon" />
                Email Address
              </li>
              <li
                className={propertyTab === "number" ? "active" : ""}
                onClick={() => setPropertyTab("number")}
              >
                <img src={callicon} alt="icon" />
                Mobile Number
              </li>
            </ul>
            {propertyTab === "email" && <Email />}
            {propertyTab === "number" && <Number />}
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
